export enum LanguageSettingsTranslations {
  title = 'languagesettings.title',
  titleLanguage = 'languagesettings.titleLanguage',
  descriptionLanguage = 'languagesettings.descriptionLanguage',
  titleContentLanguage = 'languagesettings.titleContentLanguage',
  descriptionContentLanguage = 'languagesettings.descriptionContentLanguage',
  cancel = 'languagesettings.cancel',
  saveChanges = 'languagesettings.saveChanges',
}
